/**
 * @desc create
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutMasterLendCreateRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/outStorage/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
